import axios from "axios";
const apiURL = process.env.VUE_APP_API_URL + "stations/";
import authHeader from "../services/auth-header";

const MAX_RECENT_EVENTS = 50;

function pushRecentEvent(state, event) {
  state.recentEvents.unshift({ time: new Date(), ...event });
  if (state.recentEvents.length > MAX_RECENT_EVENTS) {
    state.recentEvents.pop();
  }
}

function findStationName(state, stationId) {
  if (state.station != null && state.station._id === stationId) {
    return state.station.name;
  }
  const found = state.stations.find((s) => s._id === stationId);
  return found ? found.name : stationId;
}

export const stations = {
  state: {
    station: null,
    stations: [],
    truck: null,
    recentEvents: [],
  },
  getters: {
    oneStation: (state) => state.station,
    allStations: (state) => state.stations,
    oneTruck: (state) => state.truck,
    getRecentEvents: (state) => state.recentEvents,
  },
  mutations: {
    SOCKET_statusOnline(state, data) {
      if (state.station != null) {
        if (state.station._id == data._id) {
          state.station.statusOnline = data.statusOnline;
        }
      }
      if (state.stations.length != 0) {
        let index = state.stations.findIndex((s) => s._id === data._id);
        if (index > -1) {
          state.stations[index].statusOnline = data.statusOnline;
        }
      }
      pushRecentEvent(state, {
        station: data.name || findStationName(state, data._id),
        message: `Status: ${data.statusOnline}`,
      });
    },
    SOCKET_status(state, data) {
      if (state.station != null) {
        if (state.station._id == data.station) {
          if (data.type == "StatusEngine") {
            const index = state.station.status.findIndex(
              (s) => s.name === data.name,
            );
            if (index > -1) {
              //console.log(index);
              state.station.status[index].value = data.value;
              // console.log(state.station.status);
              console.log(data.value);
            }
          }
          if (data.name == "GPS") {
            state.station.GPS.lat = data.lat;
            state.station.GPS.lng = data.lng;
          }
        }
      }
      if (state.stations.length != 0) {
        const listIndex = state.stations.findIndex(
          (s) => s._id === data.station,
        );
        if (listIndex > -1) {
          const listStation = state.stations[listIndex];
          if (data.type == "StatusEngine") {
            const statusIndex = listStation.status.findIndex(
              (s) => s.name === data.name,
            );
            if (statusIndex > -1) {
              listStation.status[statusIndex].value = data.value;
            }
          }
          if (data.name == "GPS") {
            listStation.GPS.lat = data.lat;
            listStation.GPS.lng = data.lng;
          }
        }
      }
      pushRecentEvent(state, {
        station: findStationName(state, data.station),
        message:
          data.name == "GPS"
            ? `GPS: ${data.lat}, ${data.lng}`
            : `${data.name}: ${data.value}`,
      });
    },
    // event "stationControl" — มีคนสั่ง start/stop/pump mode จากเว็บ (อาจเป็น tab อื่นหรือผู้ใช้คนอื่น)
    SOCKET_stationControl(state, data) {
      const applyControl = (station) => {
        if (data.engine !== undefined) {
          station.engine = data.engine;
        }
        if (data.pump !== undefined) {
          station.pump = data.pump;
        }
      };

      if (state.station != null && state.station._id === data.station) {
        applyControl(state.station);
      }
      const index = state.stations.findIndex((s) => s._id === data.station);
      if (index > -1) {
        applyControl(state.stations[index]);
      }
    },
    clearRecentEvents(state) {
      state.recentEvents = [];
    },
    setStations(state, stations) {
      state.stations = stations;
    },
    setStation(state, station) {
      state.station = station;
    },
    setStationEngine(state, engine) {
      state.station.engine = engine;
    },
    setStationPump(state, pump) {
      state.station.pump = pump;
    },
    setTruck(state, truck) {
      state.truck = truck;
    },
    addStation(state, station) {
      let stations = state.stations;
      stations.push(station);
      state.stations = stations;
    },
    editStation(state, station) {
      let stations = state.stations;

      let index = stations.findIndex((element) => element._id === station._id);
      if (index != -1) {
        stations[index].name = station.name;
        state.stations = stations;
      }
    },
    deleteStation(state, id) {
      let stations = state.stations;

      let filterStation = stations.filter((element) => element._id !== id);

      state.stations = filterStation;
    },
    clearTruck(state) {
      state.truck = null;
    },
  },
  actions: {
    async getStations(context) {
      return axios
        .get(apiURL, { headers: authHeader() })
        .then((res) => {
          context.commit("setStations", res.data);
          return res;
        })
        .catch((error) => {
          console.log(error.response);
        });
    },
    createStations(context, data) {
      console.log(data);
      return axios
        .post(apiURL, data, { headers: authHeader() })
        .then((res) => {
          context.commit("addStation", res.data);
          return res;
        })
        .catch((error) => {
          console.log(error.response);
          throw error;
        });
    },
    deleteStations(context, id) {
      return axios
        .delete(apiURL + id, { headers: authHeader() })
        .then((res) => {
          context.commit("deleteStation", id);
          return res;
        })
        .catch((error) => {
          console.log(error.response);
          return error.response;
        });
    },
    editStations(context, data) {
      return axios
        .put(apiURL + data._id, data, { headers: authHeader() })
        .then((res) => {
          context.commit("editStation", res.data);
          return res;
        })
        .catch((error) => {
          console.log(error);
          throw error;
        });
    },
    async getStation(context, id) {
      return axios
        .get(apiURL + id, { headers: authHeader() })
        .then((res) => {
          if (res.data.truck == undefined) {
            context.commit("setStation", res.data);
            context.commit("clearTruck");
            // context.commit("setTruck", res.data.truck);
          } else {
            context.commit("setStation", res.data.station);
            context.commit("setTruck", res.data.truck);
          }
          return res;
        })
        .catch((error) => {
          return error.res;
        });
    },
    async setManual(context, id) {
      return axios
        .put(apiURL + "manual/" + id, { headers: authHeader() })
        .then((res) => {
          return res;
        })
        .catch((error) => {
          return error.response;
        });
    },
    async setStart(context, id) {
      return axios
        .put(apiURL + "start/" + id, { headers: authHeader() })
        .then((res) => {
          context.commit("setStationEngine", true);
          return res;
        })
        .catch((error) => {
          return error.response;
        });
    },
    async setStop(context, id) {
      return axios
        .put(apiURL + "stop/" + id, { headers: authHeader() })
        .then((res) => {
          context.commit("setStationEngine", false);
          context.commit("setStationPump", "Off Pump");
          return res;
        })
        .catch((error) => {
          return error.response;
        });
    },
    async setOnPump1(context, id) {
      return axios
        .put(apiURL + "onpump1/" + id, { headers: authHeader() })
        .then((res) => {
          context.commit("setStationPump", "Eco Mode");
          return res;
        })
        .catch((error) => {
          return error.response;
        });
    },
    async setOnPump2(context, id) {
      return axios
        .put(apiURL + "onpump2/" + id, { headers: authHeader() })
        .then((res) => {
          context.commit("setStationPump", "Normal Mode");
          return res;
        })
        .catch((error) => {
          return error.response;
        });
    },
    async setOnPump3(context, id) {
      return axios
        .put(apiURL + "onpump3/" + id, { headers: authHeader() })
        .then((res) => {
          context.commit("setStationPump", "Sport Mode");
          return res;
        })
        .catch((error) => {
          return error.response;
        });
    },
    async setOffPump(context, id) {
      return axios
        .put(apiURL + "offpump/" + id, { headers: authHeader() })
        .then((res) => {
          context.commit("setStationPump", "Off Pump");
          return res;
        })
        .catch((error) => {
          return error.response;
        });
    },
  },
};
